import type {MonitoringTranslations} from '../../types'
import {clearLocalStorage} from '../../util/storage'
import {set, pipe, lensPath} from 'ramda'

const initialState: MonitoringTranslations = {
  selectedLanguage: '',
  translations: [],
  error: '',
}
const getIndexedData = (data) => {
  const indexedArray = data.map((obj, index) => {
    let customData = {...obj, tableIndex: index}
    return customData
  })
  return indexedArray
}
export default (state: MonitoringTranslations = initialState, action): MonitoringTranslations => {
  const {type, updatedText, payload, index} = action

  switch (type) {
    case 'RESET_FORM':
      return {
        ...state,
      }
    case 'GET_TRANSLATIONS':
      return {
        ...state,
        loader: true,
      }
    case 'GET_TRANSLATIONS_SUCCESS':
      const translationsData = getIndexedData(payload.data)
      return {
        ...state,
        loader: false,
        translations: translationsData,
        error: {},
      }
    case 'GET_TRANSLATIONS_FAILURE':
      return {
        ...state,
        loader: false,
        error: payload.data || {message: 'Service is unavailable, please try again later.'},
      }
    case 'UPDATE_TRANSLATIONS':
      const changePath = ['translations', index, 'trans']
      return pipe(
        set(lensPath(changePath), updatedText),
      )(state)
    case 'LOG_OUT':
      clearLocalStorage()
      return {
        ...initialState,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/monitoring-translations/reducer.js